import { formatSalespersonCode, normalizeSalespersonCode } from '../lib/accountCollection';

/** Normalize and dedupe salesperson codes for matching. */
export function normalizeSalespersonCodes(codes: string[]): string[] {
  return [
    ...new Set(
      codes
        .map((code) => normalizeSalespersonCode(code))
        .filter(Boolean),
    ),
  ].sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }));
}

/** SA1, SA2, … SA10 (numeric-aware), then by full normalized code. */
export function compareSalespersonCodes(a: string, b: string): number {
  return normalizeSalespersonCode(a).localeCompare(normalizeSalespersonCode(b), undefined, {
    numeric: true,
    sensitivity: 'base',
  });
}

/** Canonical spaced codes for storage / dropdowns (`SA2 - RL`), sorted SA1 → SA8. */
export function formatSalespersonCodes(codes: string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const code of codes) {
    const formatted = formatSalespersonCode(code);
    if (!formatted) continue;
    const key = normalizeSalespersonCode(formatted);
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(formatted);
  }
  return out.sort(compareSalespersonCodes);
}

/** Whether a client.owner_id (salesperson code) is in the allowed code set. */
export function clientMatchesSalespersonCodes(
  clientOwnerId: string | undefined | null,
  codes: string[],
): boolean {
  const row = normalizeSalespersonCode(clientOwnerId ?? '');
  if (!row) return false;
  const allowed = normalizeSalespersonCodes(codes);
  if (allowed.length === 0) return false;
  return allowed.includes(row);
}

export function formatClientSalespersonCode(ownerId?: string | null): string {
  return formatSalespersonCode(ownerId ?? '') || '—';
}

export { formatSalespersonCode, normalizeSalespersonCode };
